import { useUpdateNodeInternals } from 'reactflow';
import { Handle } from '../Canvas';
import { BranchControlsWorkflow } from '../Workflows/BranchControl/BranchControlsWorkflow';

export const BranchControlNode = ({ id }) => {
  /*
    We need to use `useUpdateNodeInternals` in order to update the positions of the nodes in each branch correctly 
    when they have been prioritised. This forces an update in react-flow and ensures canvas shows the nodes with
    their new positions.
  */
  const updateNodeInternals = useUpdateNodeInternals();
  updateNodeInternals(id);

  return (
    <>
      <Handle type="target" position={'top' as any} />
      <BranchControlsWorkflow id={id} />
      <Handle type="source" position={'bottom' as any} />
    </>
  );
};
